const DEFAULT_PATH = '/dashboard'

/**
 * Returns the in-app path to open after login. Only same-origin relative paths are accepted
 * so the `redirect` query parameter cannot send the user to another site.
 */
export function getPostLoginPath(redirect: unknown): string {
  if (typeof redirect !== 'string') return DEFAULT_PATH

  const isRelativePath = redirect.startsWith('/') && !redirect.startsWith('//') && !redirect.startsWith('/\\')

  if (!isRelativePath || redirect.startsWith('/login')) return DEFAULT_PATH

  return redirect
}
